import React from "react";
import concatCx from "../../utils/concatCx";
import classNames from "classnames";

type ProgressProps = React.ComponentProps<"progress"> & {
    porcentage: number;
    className?: string;
};

const Progress = (props: ProgressProps) => {
    const { ...rest } = props;
    const attributes = {
        ...rest
    };
    return (
        <div>
            <label>
                {`${props.porcentage}% completado`}
            </label>
            <progress {...attributes}></progress>
        </div>
    );
};

export default Progress;
